import { render, staticRenderFns } from "./ExamPackagePracticeScore.vue?vue&type=template&id=4e4c7571&scoped=true&"
import script from "./ExamPackagePracticeScore.vue?vue&type=script&lang=js&"
export * from "./ExamPackagePracticeScore.vue?vue&type=script&lang=js&"
import style0 from "./ExamPackagePracticeScore.vue?vue&type=style&index=0&id=4e4c7571&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e4c7571",
  null
  
)

export default component.exports